var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import 'moment-timezone/builds/moment-timezone-with-data-1970-2030';
import { autoinject, transient } from 'aurelia-dependency-injection';
import { LotteryFeedCodeEnum, LotteryFeedEnum } from '../../../../../models/modules/lotteryplatofrm.models';
import { ChildComponent } from '../../../../pages/modules/child-component';
import { NotificationClientService, NotificationType } from '../../../../../services/basics/notification-client.service';
import { I18N } from 'aurelia-i18n';
import { LotteryClientService } from '../../../../../services/modules/lottery-client.service';
import * as Enumerable from 'linq';
import moment from "moment";
import { BindingEngine, computedFrom } from "aurelia-binding";
import { LotteryDateHelper } from "./lottery-date-helper";
import { DrawDateHelper } from "../../../../../models/modules/draw-date-helper";
import { StringHelper } from "../../../../../helpers/string-helper";
var LotterySettings = /** @class */ (function (_super) {
    __extends(LotterySettings, _super);
    function LotterySettings(notificationService, i18N, lotteryClientService, bindingEngine) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.bindingEngine = bindingEngine;
        _this.isRngUrlRequired = true;
        _this.isRngNotAvailable = true;
        _this.hours = Enumerable.range(0, 24).select(function (x) {
            return {
                name: _this.padWithZero(x),
                value: x
            };
        }).toArray();
        _this.minutes = Enumerable.range(0, 60).select(function (x) {
            return {
                name: _this.padWithZero(x),
                value: x
            };
        }).toArray();
        return _this;
    }
    Object.defineProperty(LotterySettings.prototype, "drawTimeTo", {
        get: function () {
            return this._drawTimeTo;
        },
        set: function (value) {
            this._drawTimeTo = value;
            this.item.drawTimeTo = moment(value.toString()).format("HH:mm");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotterySettings.prototype, "drawTimeFrom", {
        get: function () {
            return this._drawTimeFrom;
        },
        set: function (value) {
            this._drawTimeFrom = value;
            this.item.drawTimeFrom = moment(value.toString()).format("HH:mm");
        },
        enumerable: false,
        configurable: true
    });
    LotterySettings.prototype.onActivated = function (item) {
        _super.prototype.onActivated.call(this, item);
        this.monitorTimezoneChanged(item);
        this.lotteryDate = new LotteryDateHelper(item);
        this.loadTimeZones();
        if (this.item.drawTimeTo)
            this._drawTimeTo = this.getDateTimeFromTime(this.item.drawTimeTo.toString()).toString();
        if (this.item.drawTimeFrom)
            this._drawTimeFrom = this.getDateTimeFromTime(this.item.drawTimeFrom.toString()).toString();
    };
    LotterySettings.prototype.getDateTimeFromTime = function (time) {
        var timeSplit = time.split(":");
        var hour = timeSplit[0];
        var minutes = timeSplit[1];
        var date = new Date();
        date.setHours(Number(hour));
        date.setMinutes(Number(minutes));
        return date;
    };
    LotterySettings.prototype.detached = function () {
        this.clearSubscription();
    };
    LotterySettings.prototype.padWithZero = function (x) {
        return x > 9 ? ("" + x) : ("0" + x);
    };
    LotterySettings.prototype.clearSubscription = function () {
        if (this.subscriptionTimezone) {
            this.subscriptionTimezone.dispose();
        }
        if (this.subscriptionTime) {
            this.subscriptionTime.dispose();
        }
    };
    LotterySettings.prototype.monitorTimezoneChanged = function (item) {
        var _this = this;
        this.clearSubscription();
        this.subscriptionTimezone = this.bindingEngine.propertyObserver(item, "timezone")
            .subscribe(function (oldValue, newValue) {
            if (oldValue != newValue)
                _this.getFeed();
        });
        this.subscriptionTime = this.bindingEngine.propertyObserver(item, "drawTime")
            .subscribe(function (oldValue, newValue) {
            var nullValue = (oldValue == null && newValue != null) || (oldValue != null && newValue == null);
            if (nullValue || oldValue.toString() != newValue.toString())
                _this.getFeed();
        });
    };
    LotterySettings.prototype.loadTimeZones = function () {
        var time = moment;
        this.timeZones = time.tz.names().map(function (name) {
            return {
                id: name,
                name: name
            };
        });
    };
    LotterySettings.prototype.getFeed = function (forceDateChange) {
        var _this = this;
        if (forceDateChange === void 0) { forceDateChange = false; }
        if (!this.item.lotteryFeedId)
            return;
        if (this.item.isFeed == false)
            return;
        if (StringHelper.isNullOrWhiteSpace(this.item.lotteryApiCode)) {
            this.lotteryDate.drawDate = DrawDateHelper.calculateNextDrawDate(this.item.isCustom, 1, false, this.item.sunday, this.item.monday, this.item.tuesday, this.item.wednesday, this.item.thursday, this.item.friday, this.item.saturday, new Date(), new Date());
            return;
        }
        return this.lotteryClientService.getFeed({
            apiCode: this.item.lotteryApiCode
        }).then(function (x) {
            var lotteries = Enumerable.from(x.lotteryFeedGames);
            var lottery = lotteries.firstOrDefault();
            if (_this.item && _this.item.currentJackpotDraw) {
                if (_this.item && _this.item.isCustom) {
                    _this.item.currentJackpotDraw.totalJackpot = _this.item.currentJackpotDraw.totalJackpot ? _this.item.currentJackpotDraw.totalJackpot : Number(lottery.jackpot);
                    _this.item.insurerLotteryName = _this.item.insurerLotteryName ? _this.item.insurerLotteryName : lottery.gameDetails.gameName;
                    _this.item.underlyingLotteryName = lottery.gameDetails.gameName;
                    if (!_this.lotteryDate.drawDate || forceDateChange)
                        _this.lotteryDate.drawDate = DrawDateHelper.calculateNextDrawDate(_this.item.isCustom, 1, false, _this.item.sunday, _this.item.monday, _this.item.tuesday, _this.item.wednesday, _this.item.thursday, _this.item.friday, _this.item.saturday, new Date(), new Date());
                }
                else {
                    _this.item.currentJackpotDraw.totalJackpot = Number(lottery.jackpot);
                    _this.item.insurerLotteryName = _this.item.insurerLotteryName ? _this.item.insurerLotteryName : lottery.gameDetails.gameName;
                    _this.item.underlyingLotteryName = lottery.gameDetails.gameName;
                    if (_this.item.timezone) {
                        var momentTimezone = moment;
                        var dateStr = moment(lottery.nextDrawDate).format("YYYY-MM-DD");
                        var dbDate = momentTimezone.tz(dateStr + " " + _this.padWithZero(_this.item.drawTimeHours) + ":" + _this.padWithZero(_this.item.drawTimeMinutes), _this.item.timezone);
                        _this.lotteryDate.drawDate = new Date(dbDate.toJSON());
                    }
                }
            }
        }, function (e) {
            _this.notificationService.show(_this.i18N.tr('error-text') + '!', _this.i18N.tr('error-getting-data-from-feed'), NotificationType.Error);
        });
    };
    LotterySettings.prototype.calculateNextDraw = function () {
        this.getFeed(true);
    };
    LotterySettings.prototype.onSelectFeedType = function (changeEvent) {
        switch (changeEvent.detail.item.id) {
            case LotteryFeedEnum.RngPick3:
                this.item.isFeed = false;
                this.isRngUrlRequired = false;
                this.selectedLotteryFeedData = false;
                this.item.lotteryApiCode = LotteryFeedCodeEnum.RngPick3;
                break;
            case LotteryFeedEnum.RNG:
                this.selectedLotteryFeedData = true;
                this.isRngUrlRequired = true;
                this.item.isFeed = false;
                this.item.lotteryApiCode = LotteryFeedCodeEnum.RNG;
                break;
            case LotteryFeedEnum.Feed:
                if (this.item.lotteryApiCode == LotteryFeedCodeEnum.RngPick3
                    || this.item.lotteryApiCode == LotteryFeedCodeEnum.RNG) {
                    this.item.lotteryApiCode = "";
                }
                this.item.isFeed = true;
                this.isRngUrlRequired = false;
                this.selectedLotteryFeedData = false;
                this.calculateNextDraw();
                break;
        }
    };
    __decorate([
        computedFrom("_drawTimeTo"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LotterySettings.prototype, "drawTimeTo", null);
    __decorate([
        computedFrom("_drawTimeFrom"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LotterySettings.prototype, "drawTimeFrom", null);
    LotterySettings = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            LotteryClientService, BindingEngine])
    ], LotterySettings);
    return LotterySettings;
}(ChildComponent));
export { LotterySettings };
